import type { FC } from "react";
import { useLocation } from "react-router";
import { NavigationSearchContainer } from "../../../features/search/navigationSearchContainer.js";
import { resourceTypeIcons } from "../resourceTypeIcons.js";
import { matchesNavPath, NavigationMenu } from "./navigationMenu.js";
import type { NavigationMenuItemProps } from "./navigationMenuItem.js";

export const TrainingNavigationMenu: FC = () => {
  const { pathname } = useLocation();

  const items: readonly NavigationMenuItemProps[] = [
    {
      label: "Trainings",
      href: "/train",
      icon: (
        <resourceTypeIcons.training aria-hidden className="size-4 shrink-0" />
      ),
      // Also active on project detail routes, which belong to this section.
      isActive:
        matchesNavPath(pathname, "/train") ||
        matchesNavPath(pathname, "/project"),
    },
  ];

  return (
    <NavigationMenu
      items={items}
      search={<NavigationSearchContainer context="training" />}
    />
  );
};
